import {TEvaluationDimensions} from '../types/types'

export const dimensionOrder: (keyof TEvaluationDimensions)[] = [
  'comprehensibilty',
  'credibility',
  'bodyLanguage',
  'vocalQuality',
  'stylisticDevices'
]
